import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { EventTemplateService } from './event-template.service';
import { EventTemplateModel } from './event-template.model';
import { ResourceData } from '@app/shared/abstract/resource.data';

@Injectable({
  providedIn: 'root'
})
export class EventTemplateResolver implements Resolve<ResourceData<EventTemplateModel>> {
  constructor(private eventTemplateService: EventTemplateService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ResourceData<EventTemplateModel>> {
    const id = route.paramMap.get('id');
    if (id && id !== 'new') {
      return this.eventTemplateService.getById(id);
    }
    
    // Return empty template for new template creation
    const emptyTemplate: EventTemplateModel = {
      id: null,
      name: '',
      event_type: 'Wedding',
      description: '',
      created_by: 0,
      updated_by: 0,
      created_at: null,
      updated_at: null,
      items: []
    };

    return new Observable(observer => {
      observer.next({ data: emptyTemplate });
      observer.complete();
    });
  }
}